import { Spinner } from '@talentmesh/ui/components/spinner';

const InfiniteScrollDefaultLoader = () => {
    return (
        <div className="mt-4 flex justify-center">
            <Spinner className="text-primary size-8" />
        </div>
    );
};

export default InfiniteScrollDefaultLoader;
